import { call, put, takeEvery } from 'redux-saga/effects';

import { AxiosResponse } from 'axios';
import { ConnectorBase } from 'pages/Connectors/types';
import { SagaPayload } from 'types/saga';
import {
  getConnectorsError,
  getConnectorsSuccess,
  requestConnectors,
  requestCreateConnector,
  requestUpdateConnector,
} from './slice';
import { ConnectorData } from '../types';
import { createConnector, editConnector, getIntegrationsStatus } from '../../../api/system';

export function* connectorsRequestSaga() {
  try {
    const response: AxiosResponse<ConnectorData[]> = yield call(getIntegrationsStatus, {});
    if (response) {
      yield put(getConnectorsSuccess({ connectors: response.data }));
    }
  } catch (error) {
    yield put(getConnectorsError(error.message));
  }
}

export function* createConnectorRequestSaga({ payload }: SagaPayload<ConnectorBase>) {
  try {
    const response: AxiosResponse<ConnectorData[]> = yield call(createConnector, payload);
    if (response) {
      yield put(getConnectorsSuccess({ connectors: response.data }));
    }
  } catch (error) {
    yield put(getConnectorsError(error.message));
  }
}

export function* editConnectorRequestSaga({ payload }: SagaPayload<ConnectorBase>) {
  try {
    const response: AxiosResponse<ConnectorData[]> = yield call(editConnector, payload);
    if (response) {
      yield put(getConnectorsSuccess({ connectors: response.data }));
    }
  } catch (error) {
    yield put(getConnectorsError(error.message));
  }
}

export function* connectorsRequestWatchSaga() {
  yield takeEvery(requestConnectors, connectorsRequestSaga);
}

export function* createConnectorRequestWatchSaga() {
  yield takeEvery(requestCreateConnector, createConnectorRequestSaga);
}

export function* editConnectorRequestWatchSaga() {
  yield takeEvery(requestUpdateConnector, editConnectorRequestSaga);
}
